export enum LOADING_ACTION_TYPES {
    SET_IS_LOADING = 'loading/SET_IS_LOADING',
    SET_PROGRESS = 'loading/SET_PROGRESS',
}